import React from "react";
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Link,
  Button,
  Paper,
  Divider,
  Fade
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from 'react-i18next';

export const InstructionCheckbox = ({
  instructionsChecked,
  setInstructionsChecked,
  handleInstructionLinkClick,
  activeTab,
  setActiveTab,
  formik,
}) => {
  const { t } = useTranslation();

  return (
    <Fade in timeout={600}>
      <Paper
        elevation={6}
        sx={{
          p: 4,
          bgcolor: "background.paper",
          borderRadius: 3,
          maxWidth: 600,
          mx: "auto",
          mt: 4,
          border: theme => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box display="flex" alignItems="center" mb={2}>
          <InfoOutlinedIcon color="primary" sx={{ mr: 1 }} />
          <Typography variant="h6" fontWeight="600">
            {t('instructionCheckbox.importantInstructions')}
          </Typography>
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              name="instructionsChecked"
              checked={formik.values.instructionsChecked}
              onChange={formik.handleChange}
              sx={{
                color:
                  formik.errors.instructionsChecked &&
                  formik.touched.instructionsChecked
                    ? "error.main"
                    : "primary.main",
                "&.Mui-checked": {
                  color:
                    formik.errors.instructionsChecked &&
                    formik.touched.instructionsChecked
                      ? "error.main"
                      : "primary.main",
                },
                transform: "scale(1.2)",
              }}
            />
          }
          label={
            <Typography variant="body1">
              <Link
                href="#"
                onClick={handleInstructionLinkClick}
                underline="hover"
                color="primary"
                sx={{
                  fontWeight: 500,
                  "&:hover": { color: "secondary.main" },
                }}
              >
                {t('instructionCheckbox.readInstructionsLink')}
              </Link>
            </Typography>
          }
        />

        <Divider sx={{ my: 3 }} />

        <Box
          sx={{
            backgroundColor: "grey.50",
            borderRadius: 2,
            p: 2,
            boxShadow: "inset 0 0 5px rgba(0,0,0,0.05)",
            lineHeight: 1.8,
          }}
        >
          <Typography variant="body1" component="div">
            <strong>{t('instructionCheckbox.notesLabel')}</strong><br />
            1. {t('instructionCheckbox.note1')}<br />
            2. {t('instructionCheckbox.note2')}<br />
            3. {t('instructionCheckbox.note3')}
          </Typography>
        </Box>

        {formik.errors.instructionsChecked && formik.touched.instructionsChecked && (
          <Typography
            color="error"
            variant="body2"
            sx={{ mt: 1, fontWeight: 500 }}
          >
            {formik.errors.instructionsChecked}
          </Typography>
        )}

        <Button
          fullWidth
          variant="contained"
          size="large"
          sx={{
            mt: 3,
            py: 1,
            fontWeight: 600,
            borderRadius: 2,
            textTransform: "none",
            transition: "0.3s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            },
          }}
          onClick={() => {
            formik.setFieldTouched("instructionsChecked", true);
            formik.validateForm().then((errors) => {
              if (!errors.instructionsChecked) {
                formik.handleSubmit();
              }
            });
          }}
        >
          {t('instructionCheckbox.next')}
        </Button>
      </Paper>
    </Fade>
  );
};


// import React from "react";
// import {
//   Box,
//   FormControlLabel,
//   Checkbox,
//   Typography,
//   Link,
//   Button,
//   Paper,
//   Divider,
//   Fade,
// } from "@mui/material";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
// import { useTranslation } from "react-i18next";

// const NoteItem = ({ number, text }) => (
//   <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", mb: 1.5 }}>
//     <Box
//       sx={{
//         width: 24,
//         height: 24,
//         borderRadius: "8px",
//         background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         flexShrink: 0,
//         mt: 0.2,
//       }}
//     >
//       <Typography sx={{ color: "#fff", fontSize: "0.7rem", fontWeight: 800, fontFamily: "'DM Sans', sans-serif" }}>
//         {number}
//       </Typography>
//     </Box>
//     <Typography
//       sx={{
//         fontSize: "0.88rem",
//         color: "#475569",
//         fontFamily: "'DM Sans', sans-serif",
//         lineHeight: 1.6,
//       }}
//     >
//       {text}
//     </Typography>
//   </Box>
// );

// export const InstructionCheckbox = ({
//   instructionsChecked,
//   setInstructionsChecked,
//   handleInstructionLinkClick,
//   activeTab,
//   setActiveTab,
//   formik,
// }) => {
//   const { t } = useTranslation();

//   return (
//     <Fade in timeout={700}>
//       <Box
//         sx={{
//           maxWidth: 640,
//           mx: "auto",
//           mt: 3,
//         }}
//       >
//         {/* Hero banner */}
//         <Box
//           sx={{
//             borderRadius: "20px",
//             background: "linear-gradient(135deg, #1e293b 0%, #1e3a5f 50%, #1e293b 100%)",
//             p: 4,
//             mb: 3,
//             position: "relative",
//             overflow: "hidden",
//             textAlign: "center",
//           }}
//         >
//           {/* Decorative circles */}
//           <Box sx={{ position: "absolute", top: -30, right: -30, width: 120, height: 120, borderRadius: "50%", background: "rgba(59,130,246,0.15)" }} />
//           <Box sx={{ position: "absolute", bottom: -20, left: -20, width: 80, height: 80, borderRadius: "50%", background: "rgba(139,92,246,0.15)" }} />

//           <Box
//             sx={{
//               width: 64,
//               height: 64,
//               borderRadius: "20px",
//               background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               mx: "auto",
//               mb: 2.5,
//               boxShadow: "0 8px 28px rgba(59,130,246,0.5)",
//             }}
//           >
//             <InfoOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
//           </Box>
//           <Typography
//             variant="h5"
//             sx={{
//               fontWeight: 800,
//               color: "#fff",
//               fontFamily: "'DM Sans', sans-serif",
//               mb: 0.75,
//             }}
//           >
//             {t("instructionCheckbox.importantInstructions")}
//           </Typography>
//           <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: "0.875rem", fontFamily: "'DM Sans', sans-serif" }}>
//             Please read carefully before starting your claim
//           </Typography>
//         </Box>

//         {/* Checkbox card */}
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: "20px",
//             border: formik.errors.instructionsChecked && formik.touched.instructionsChecked
//               ? "2px solid #ef4444"
//               : instructionsChecked
//               ? "2px solid #10b981"
//               : "1.5px solid #e2e8f0",
//             background: instructionsChecked
//               ? "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)"
//               : "#fff",
//             p: 3,
//             mb: 3,
//             transition: "all 0.3s ease",
//             cursor: "pointer",
//           }}
//           onClick={() => {
//             if (!instructionsChecked) handleInstructionLinkClick({ preventDefault: () => {} });
//           }}
//         >
//           <FormControlLabel
//             onClick={(e) => e.stopPropagation()}
//             control={
//               <Checkbox
//                 name="instructionsChecked"
//                 checked={formik.values.instructionsChecked}
//                 onChange={(e) => {
//                   formik.handleChange(e);
//                   setInstructionsChecked(e.target.checked);
//                 }}
//                 sx={{
//                   color: formik.errors.instructionsChecked && formik.touched.instructionsChecked
//                     ? "#ef4444"
//                     : "#3b82f6",
//                   "&.Mui-checked": { color: "#10b981" },
//                   "& .MuiSvgIcon-root": { fontSize: 26 },
//                 }}
//               />
//             }
//             label={
//               <Box>
//                 <Typography sx={{ fontWeight: 600, color: "#1e293b", fontFamily: "'DM Sans', sans-serif", fontSize: "0.95rem" }}>
//                   I have read and understood the{" "}
//                   <Link
//                     href="#"
//                     onClick={(e) => { e.stopPropagation(); handleInstructionLinkClick(e); }}
//                     underline="always"
//                     sx={{
//                       color: "#3b82f6",
//                       fontWeight: 700,
//                       textDecorationColor: "#bfdbfe",
//                       "&:hover": { color: "#2563eb" },
//                     }}
//                   >
//                     {t("instructionCheckbox.readInstructionsLink")}
//                   </Link>
//                 </Typography>
//                 {instructionsChecked && (
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
//                     <CheckCircleOutlineIcon sx={{ color: "#10b981", fontSize: 16 }} />
//                     <Typography sx={{ fontSize: "0.78rem", color: "#10b981", fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>
//                       Instructions acknowledged
//                     </Typography>
//                   </Box>
//                 )}
//               </Box>
//             }
//             sx={{ width: "100%", m: 0 }}
//           />
//         </Paper>

//         {formik.errors.instructionsChecked && formik.touched.instructionsChecked && (
//           <Typography sx={{ color: "#ef4444", fontSize: "0.8rem", fontWeight: 600, fontFamily: "'DM Sans', sans-serif", mb: 2, textAlign: "center" }}>
//             ⚠️ {formik.errors.instructionsChecked}
//           </Typography>
//         )}

//         {/* Notes card */}
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: "20px",
//             border: "1.5px solid #fde68a",
//             background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
//             p: 3,
//             mb: 3,
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
//             <Box
//               sx={{
//                 width: 36,
//                 height: 36,
//                 borderRadius: "10px",
//                 background: "linear-gradient(135deg, #f59e0b, #d97706)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 boxShadow: "0 4px 12px rgba(245,158,11,0.3)",
//               }}
//             >
//               <LightbulbOutlinedIcon sx={{ color: "#fff", fontSize: 20 }} />
//             </Box>
//             <Typography sx={{ fontWeight: 800, color: "#92400e", fontSize: "0.9rem", fontFamily: "'DM Sans', sans-serif" }}>
//               {t("instructionCheckbox.notesLabel") || "Important Notes"}
//             </Typography>
//           </Box>
//           <NoteItem number="1" text={t("instructionCheckbox.note1")} />
//           <NoteItem number="2" text={t("instructionCheckbox.note2")} />
//           <NoteItem number="3" text={t("instructionCheckbox.note3")} />
//         </Paper>

//         {/* CTA Button */}
//         <Button
//           fullWidth
//           variant="contained"
//           size="large"
//           onClick={() => {
//             formik.setFieldTouched("instructionsChecked", true);
//             formik.validateForm().then((errors) => {
//               if (!errors.instructionsChecked) formik.handleSubmit();
//             });
//           }}
//           sx={{
//             borderRadius: "14px",
//             height: 56,
//             background: instructionsChecked
//               ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
//               : "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
//             fontWeight: 800,
//             fontFamily: "'DM Sans', sans-serif",
//             fontSize: "1rem",
//             letterSpacing: "0.02em",
//             boxShadow: instructionsChecked
//               ? "0 6px 24px rgba(16,185,129,0.4)"
//               : "0 6px 24px rgba(59,130,246,0.35)",
//             "&:hover": {
//               background: instructionsChecked
//                 ? "linear-gradient(135deg, #059669 0%, #047857 100%)"
//                 : "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
//               transform: "translateY(-2px)",
//               boxShadow: instructionsChecked
//                 ? "0 10px 32px rgba(16,185,129,0.5)"
//                 : "0 10px 32px rgba(59,130,246,0.45)",
//             },
//             transition: "all 0.3s ease",
//           }}
//         >
//           {instructionsChecked ? "✓ Proceed to Next Step" : t("instructionCheckbox.next")} →
//         </Button>
//       </Box>
//     </Fade>
//   );
// };